<template>
    <!-- <div> -->
        <ScheduleList
            v-if="currentSchedule=='list'"
            class="c-scheduleV2"
            :currentDate="currentDate"
            :userProfileID="userProfileID"
			@set-current-date="$emit('set-current-date', $event)"
        />
        <ScheduleCalendar
            v-else
            class="c-scheduleV2"
            :currentDate="currentDate"
            :inboxUserProfileID="userProfileID"
			@set-current-date="$emit('set-current-date', $event)"
        />
    <!-- </div> -->
</template>
<script>
    import ScheduleList from '@/components/schedule/ScheduleList'
    import ScheduleCalendar from '@/components/schedule/ScheduleCalendar'
    import { MYPROFILE } from '@/graphql/user/queries'

    export default {
        name: 'ScheduleV2',
        components: { ScheduleList, ScheduleCalendar },
        props: {
            isMobile: {
                type: Boolean,
                default: false
            },
			currentDate: {
                type: String,
                default: null
            },
			currentSchedule: {
                type: String,
                default: 'list'
            },
			inboxUserProfile: {
				type: Object,
				default: null,
			}
        },
        data(){
        	return {
                userProfileID: null
        	}
        },
        mounted(){

			// if(!this.inboxUserProfile){
            this.userProfileID=this.myProfile.id;
            this.$emit('change-inbox', this.myProfile)
			// }else{ 
				// this.userProfileID=this.inboxUserProfile.id
			// }

        },
        //computed: {},
        watch: {
			inboxUserProfile: function(){
				if(this.inboxUserProfile) this.userProfileID=this.inboxUserProfile.id;
			}
        },
        //methods: {},
        apollo: {
			myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
				},
				update(data){
					if(!this.inboxUserProfileID) this.userProfileID=data.myProfile.id
					return data.myProfile
				}
			},
        }
    }
</script>
<style lang="scss">
    @import "@/scss/components/dashboard/ScheduleV2.scss";
</style>